export default __webpack_public_path__ + "static/media/AWS_Infrastructure.20060e52.svg";